import { render, staticRenderFns } from "./CollectListUpdateLayout.vue?vue&type=template&id=32e19558&scoped=true"
import script from "./CollectListUpdateLayout.vue?vue&type=script&lang=js"
export * from "./CollectListUpdateLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e19558",
  null
  
)

export default component.exports